import withRoot from '../../../src/components/withRoot';
import React, {Fragment} from 'react';
import makeStyles from "@material-ui/core/styles/makeStyles";
import {Typography} from "@material-ui/core";
import TablaEmisionesVehiculo from "../../components/adviser/Documentation/TablaEmisionesVehiculo";
import TablaEmisionesCombinado from "../../components/adviser/Documentation/TablaEmisionesCombinado";
import TablaEmisionesOtros from "../../components/adviser/Documentation/TablaEmisionesOtros";
import TablaEmisionesMicroseguro from "../../components/adviser/Documentation/TablaEmisionesMicroseguro";
import Header from "../../components/adviser/Dashboard/Header";
import TablaEmisionesPrevencion from "../../components/adviser/Documentation/TablaEmisionesPrevencion";
import TablaEmisionesMotovehiculo from "../../components/adviser/Documentation/TablaEmisionesMotovehiculo";

const useStyle = makeStyles((theme) => ({
    body: {
        marginTop: theme.spacing(3),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
    },
    appBarSpacer: theme.mixins.toolbar,
    title: {
        fontSize: '24px',
        color: '#BB0D66',
        fontFamily: 'EncodeSansRegular',
        fontWeight: 800
    },
    table: {
        marginTop: "8px",
        marginBottom: "32px"
    }
}));

const getTabla = ((producto) => {
    switch (producto) {
        case 'vehiculo':
            return <TablaEmisionesVehiculo/>
        case 'motovehiculo':
            return <TablaEmisionesMotovehiculo/>
        case 'combinado':
            return <TablaEmisionesCombinado/>
        case 'microseguro':
            return <TablaEmisionesMicroseguro/>
        case 'otros':
            return <TablaEmisionesOtros/>
        case 'prevencion':
            return <TablaEmisionesPrevencion/>
    }
})

function Documentacion(props) {
    const classes = useStyle();

    return (
        <Fragment>
            <div style={{display: "flex", flexDirection: "row", width: "100%", marginBottom: "30px"}}>
                <Header/>
            </div>
            <div className={classes.body}>
                <Typography className={classes.title}>
                    Pólizas - documentación
                </Typography>
                <div>
                    {getTabla(props.location.state.producto)}
                </div>
            </div>
        </Fragment>
    )
}

export default withRoot(Documentacion);